export default __webpack_public_path__ + "static/media/soft_ring.b811b3be.wav";